exports.default = {
  'build_success': 'build success',
  'build_failed': 'build failed',
  'build_version': 'version: ',
  'click_to_detail': 'Click to view details',
  'permission_box_title': 'Notify me upon task completion',
  'permission_box_msg': 'After the task is completed, you will be notified through the browser',
  'permission_box_btn': 'Enable notifications',
  'permission_not_granted': 'You have disabled browser notification permissions. Please manually enable them in your browser settings',
  'permission_denied': 'You have refused browser notification permission',
  'bill_permission_box_title': 'Notify me after the order is completed',
  'bill_permission_box_msg': 'After the order is completed, you will be notified through the browser'
}
